export default __webpack_public_path__ + "img/parking_device.fd3e5c736ae2f0db433a93468cee0727.png";